import api from '@/apis/di/budgetItemAPI';
import Crud from '@/stores/crudBase.js';
var crud = new Crud('budgetItem', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_budget_item',
    field: {
      key: 'budget_item_id',
      code: 'budget_item_code',
      name: 'budget_item_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
